module.exports = __webpack_public_path__ + "static/img/basics.3c44f021.png";